import React, { memo } from 'react'
import { oneOfType, number, string } from 'prop-types'

export const Plus = memo(({ color = '#FFA06A', height = 20, width = 20 }) => {
	return (
		<svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 22.6 22.6"
			style={{ enableBackground: 'new 0 0 22.6 22.6' }}
			xmlSpace="preserve"
		>
			<line
				fill="none"
				stroke={color}
				strokeWidth={2.1}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				x1="11.3"
				y1="1"
				x2="11.3"
				y2="21.5"
			/>
			<line
				fill="none"
				stroke={color}
				strokeWidth={2.1}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				x1="1"
				y1="11.3"
				x2="21.5"
				y2="11.3"
			/>
		</svg>
	)
})
Plus.propTypes = {
	color: string,
	height: oneOfType([number, string]),
	width: oneOfType([number, string]),
}
